import platform from 'platform'

export const isFirefox = platform.name === 'Firefox'
export const isChrome = platform.name === 'Chrome'

export const userAgent = `n2p.dialer/${
  process.env.REACT_APP_N2P_VERSION
} (${platform.toString()})`

export const getViewPortSize = () => {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  }
}
